export default __webpack_public_path__ + "static/media/img-0191-ireland-half-face.b2a06612.png";